import "bootstrap/dist/css/bootstrap.min.css";
import { Image } from "react-bootstrap";
import {
    StarList,
    CardRatingText,
    SerchpageText,
} from "./ratingStarStyle";
import Full_star from "../../../assests/images/full-star.svg";
import Half_star from "../../../assests/images/half-star.svg";
import WhiteFullStar from "../../../assests/images/white-full-star.svg";
import WhiteHalfStar from "../../../assests/images/white-half-star.svg";
import { RatingStarProps } from "../../../utils/types";
import { MESSAGE } from "../../../utils/message";
import star_thin from "../../../assests/images/icons.png";

const RatingStar = ({ review, rating = 0, color = "golden" }: RatingStarProps) => {

    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
     const emptyStars = Math.max(0, 5 - (fullStars + (hasHalfStar ? 1 : 0)));


    return (
        <SerchpageText>

            <div className="rating-col">

                <CardRatingText className="RatingReview">{review ? `${review} ${MESSAGE.reviews}` : `0 ${MESSAGE.reviews}`}</CardRatingText>
                {/* {rating > 0 && <StarList className="rating-star">
                    {[...Array(fullStars)]?.map((_, index) => (<Image key={index + 1} src={color === "golden" ? Full_star : WhiteFullStar} className="full-star" alt="rating star" width="15px" height="14px" />
                    ))}
                    {hasHalfStar && (
                        <Image src={color === "golden" ? Half_star : WhiteHalfStar} className="half-star" alt="rating star" width="15px" height="14px" />
                    )}
                </StarList>} */}
                <StarList className="rating-star">
                    {/* Render Full Stars */}
                    {[...Array(fullStars)].map((_, index) => (
                        <Image
                            key={`full-${index}`}
                            src={color === "golden" ? Full_star : WhiteFullStar}
                            className="full-star"
                            alt="rating star"

                        />
                    ))}

                    {/* Render Half Star */}
                    {hasHalfStar && (
                        <Image
                            src={color === "golden" ? Half_star : WhiteHalfStar}
                            className="half-star"
                            alt="rating star"

                        />
                    )}

                    {/* Render Empty Stars */}
                    {[...Array(emptyStars)].map((_, index) => (

                        <Image
                            key={`empty-${index}`}
                            src={color === "golden" ? star_thin : star_thin} // Change this if you have an empty star icon
                            className="empty-star"
                            alt="empty star"
                            width="18px"
                            height="18px"
                        />

                    ))}
                </StarList>
            </div>
        </SerchpageText>
    );
}
export default RatingStar;